<div class="mat-mdc-card example-card">

  <div style="position: absolute;z-index: 10000;top:0;right: 0;">
    <ng-content select="[topRight]">

    </ng-content>
  </div>
  <mat-grid-list cols="12" rowHeight="25px">
    <mat-grid-tile [colspan]="12"
      [rowspan]="7"
      class="principlaGridTile"
      [ngStyle]="{background: backGroundColor}">
      @if (image!=undefined && image!=null) {
        <div class="principal-image-container" style="margin: 0px">
          <img src="{{image.url}}"
            class="principal-image">
        </div>
      } @else {
        @if (!isNewProject) {
          <div class="noImage"
            [ngStyle]="{backgroundImage: 'url(assets/icon/background/noConfine.png)'}">
          </div>
        } @else {
          <div class="newProject">
            <div class="plus radius">
            </div>
          </div>
        }
      }
      @if (!isNewProject && loading&&logo!=undefined) {
        <div class="logo-container" style="text-align: center;align-items: center"
          >
          <img src="{{logo.url}}" alt="{{logo.url}}"
            class="logo-image">
          <!--                <ng-template #nologo>-->
          <!--                    <div class="noLogo" [ngStyle]="{fontSize: resizeText(),color:'black'}">{{sigla}}</div>-->
        <!--                </ng-template>-->
      </div>
    }
  </mat-grid-tile>
  <mat-grid-tile [colspan]="12"
    [rowspan]="2">
    <h4>
      {{ name }}
    </h4>
  </mat-grid-tile>
  <mat-grid-tile [colspan]="12"
    [rowspan]="1">
    <h5> {{ referenceName }}</h5>
  </mat-grid-tile>
</mat-grid-list>
</div>
